import { alternateLinks, rootCanonicalUrl } from "@/config/canonical";
import { useTranslation } from "@repo/shared/i18n";
import { BatteryFull, Signal, Wifi } from "lucide-react";
import { Helmet } from "react-helmet-async";

import { CompareMobile } from "./CompareMobile";

/**
 * Mobile preview of the Compare Players screen (`/compare/mobile`): the
 * comparison rendered inside a 360px phone shell — status bar + screen — so
 * it reads clearly as the mobile view. The screen itself (CompareMobile)
 * measures its own width, so the shell is just presentation.
 */
const CompareMobilePage = () => {
  const { t } = useTranslation("compare");
  return (
    <>
      <Helmet>
        <title>{t("mobile.title")}</title>
        <link rel="canonical" href={rootCanonicalUrl("/compare")} />
        {alternateLinks(rootCanonicalUrl("/compare"))}
        <meta name="description" content={t("mobile.metaDescription")} />
      </Helmet>
      <div className="flex justify-center px-4 py-10">
        <div className="w-[372px] shrink-0 overflow-hidden rounded-[36px] border-[6px] border-neutral-700 bg-neutral-900 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
          <div className="flex h-[720px] flex-col">
            {/* Status bar */}
            <div className="flex items-center justify-between bg-neutral-900 px-5 pb-1 pt-2 text-[11px] font-semibold text-neutral-200">
              <span>9:41</span>
              <span className="flex items-center gap-x-1.5">
                <Signal className="size-3" />
                <Wifi className="size-3.5" />
                <BatteryFull className="size-4" />
              </span>
            </div>
            {/* 360px-wide screen */}
            <div className="min-h-0 grow">
              <CompareMobile />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompareMobilePage;
